import {
    HOTEL_STATUS_LABELS,
    formatNullableTimeOnly,
} from "consts/hotel";

const nullable = (value) =>
    value == null || value === "" ? "" : String(value);

export const mapHotelRow = (item) => ({
    id: item.SFHotelId,
    nombre: item.SFHotelNombre,
    provincia: item.provinciaNombre,
    localidad: item.localidadNombre,
    calle: item.SFHotelDomicilioCalle,
    numero: item.SFHotelDomicilioCasa,
    checkin: formatNullableTimeOnly(item.SFHotelCheckin),
    checkout: formatNullableTimeOnly(item.SFHotelCheckout),
    email: nullable(item.SFHotelEmail),
    telefono: nullable(item.SFHotelTelefono),
    status: HOTEL_STATUS_LABELS[item.SFHotelStatus] ?? item.SFHotelStatus,
    SFHotelId: item.SFHotelId,
    SFHotelVersion: item.SFHotelVersion,
    SFHotelStatus: item.SFHotelStatus,
    SFHotelNombre: item.SFHotelNombre,
    cuit: item.SFHotelCUIT,
    SFHotelDomicilioCalle: item.SFHotelDomicilioCalle,
    SFHotelDomicilioCasa: item.SFHotelDomicilioCasa,
    SFHotelDomicilioCPA: item.SFHotelDomicilioCPA,
    SFHotelCheckin: item.SFHotelCheckin,
    SFHotelCheckout: item.SFHotelCheckout,
    SFHotelLatitud: item.SFHotelLatitud,
    SFHotelLongitud: item.SFHotelLongitud,
    SFHotelEmail: item.SFHotelEmail,
    SFHotelTelefono: item.SFHotelTelefono,
    provinciaId: item.provinciaId,
    localidadId: item.localidadId,
    localidadNombre: item.localidadNombre,
    provinciaNombre: item.provinciaNombre,
});

export const mapHotelList = (result) => {
    if (!Array.isArray(result) || !result[0]?.SFHotelId) {
        return [];
    }
    return result.map((item) => mapHotelRow(item));
};
